// Custom Toast
// https://www.youtube.com/watch?v=nX_xDBR_gqo&list=PLC3y8-rFHvwhAh1ypBvcZLDO6I7QTY5CM&index=3
// https://codesandbox.io/s/formik-material-ui-date-picker-with-yup-validate-3odn7?file=/src/index.js
// https://codesandbox.io/s/sparkling-cloud-2zxtk?file=/src/App.jsx
// https://codesandbox.io/s/3n78l?file=/demo.js

// https://codesandbox.io/s/autocomplete-getoptionselected-b6n3s
// https://codesandbox.io/s/autocomplete-getoptionselected-b6n3s?file=/src/App.tsx

import React, { useState } from "react";
import FormikControl from "../FormikControls/FormikControls";
import FormControl from "@material-ui/core/FormControl";
import { useForm, FormProvider } from "react-hook-form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
// import { yupResolver } from "@hookform/resolvers";
import { yupResolver } from "@hookform/resolvers/yup";
import { Formik, Form, Field, setNestedObjectValues } from "formik";

import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

import DateFnsUtils from "@date-io/date-fns";
import "date-fns";
// import {
//   MuiPickersUtilsProvider,
//   KeyboardTimePicker,
//   KeyboardDatePicker,
// } from "@material-ui/pickers";

import MomentUtils from "@date-io/moment";
import {
  MuiPickersUtilsProvider,
  TimePicker,
  DatePicker,
} from "material-ui-pickers";
import { NaturePeopleOutlined } from "@material-ui/icons";

import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

import AutocompleteList from "../FormikControls/AutocompleteList";
import SelectList from "../FormikControls/SelectList";

toast.configure();

function Employee() {
  //   return <div className="content-wrapper">Employee</div>;

  const divdataRef = React.createRef();

  let formikObj = null;

  // const [age, setAge] = React.useState("");
  // const handleChange = (event) => {
  //   console.log("select: ", event);
  //   setAge(event.target.value);
  // };

  const [stateAutocompleteList, setAutocompleteList] = React.useState(states);

  // const handleChangeAutocompleteList = (e, v) => {
  //   console.log("Employee Auto: ", v);
  //   // props.setState(v);
  //   setAutocompleteList(v);
  //   // formikobj.setFieldValue(`${name}`, JSON.stringify(v));
  //   // formikobj.setFieldValue(`${name}`, [{name:`${v.name}`,abbr:`${v.abbr}`}]);
  //   try {
  //     formikobj.setFieldValue("listofstates", [
  //       { name: `${v.name}`, abbr: `${v.abbr}` },
  //     ]);
  //   } catch (err) {
  //     formikobj.setFieldValue("listofstates", null);
  //   }
  // };

  const [selectedDate, setSelectedDate] = React.useState(
    // new Date("2014-08-18T21:11:54")
    new Date()
    // null
  );
  const handleDateChange = (date) => {
    setSelectedDate(date);
    console.log("Date:", date);
  };

  const initialValues = {
    empname: "",
    birthDate: null,
    // dob: null,
    isactive: null,
    gender: null,
    active: null,
    listofstates: null,
    listofage: null,
  };
  const validationSchema = Yup.object({
    empname: Yup.string().required("Required"),
    birthDate: Yup.date().required("Date Required").nullable(),
    // dob: Yup.date().required("Date Required").nullable(),
    isactive: Yup.boolean().required("Is Active Required").nullable(),
    active: Yup.boolean().required("Active Required").nullable(),
    gender: Yup.string().required("Gender Required").nullable(),
    // listofstates: Yup.string().required("State Required").nullable(),
    listofstates: Yup.array()
      .of(
        Yup.object().shape({
          name: Yup.string().required("Name required"),
          abbr: Yup.string().required("Abbr Required"),
        })
      )
      .required("State Required")
      .nullable(),
    listofage: Yup.array()
      .of(
        Yup.object().shape({
          age: Yup.string().required("Age Required"),
          value: Yup.string().required("Value required"),
        })
      )
      .required("Age Required")
      .nullable(),
  });

  const methods = useForm({
    resolver: yupResolver(validationSchema),
  });
  const { handleSubmit, errors } = methods;

  const onSubmit = (values) => {
    console.log("Form Data: ", values);
    divdataRef.current.innerHTML = JSON.stringify(values);
    toast.success("Data Saved Successfully!", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(formik) => {
        formikObj = formik;
        console.log("Formik Obj: ", formik);
        // formik.setFieldTouched('listofage',true)
        return (
          <div className="content-wrapper">
            {/* <div style={{display:'flex',justifyContent:'center'}}> */}
            <section className="content-header">
              <div className="container-fluid">
                <div
                  className="row"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <h1>Employee</h1>
                </div>
              </div>
            </section>

            <section className="content">
              <div className="container-fluid">
                <div
                  className="row"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  {/* <div className="col-md-13"> */}
                  <div className="card card-primary card-outline">
                    <div className="card-body box-profile">
                      <Form>
                        <FormikControl
                          control="input"
                          name="empname"
                          // required
                          label="Name"
                        />

                        <FormikControl
                          control="date"
                          id="birthDate"
                          name="birthDate"
                          label="Birth Date"
                          // disableToolbar
                          views={["year", "month", "date"]}
                          formikobj={formik}
                          // disableToolbar
                          // value={formik.values.date}
                          // onChange={(value) => {
                          //   console.log("onChange Date: ", value);
                          //   formik.setFieldValue("birthDate", value);
                          // }}

                          // value={selectedDate}
                          // onChange={(value) => {
                          //   handleDateChange(value);
                          //   formik.setFieldValue("birthDate", value);
                          // }}
                        />

                        {/* <FormikControl
                          control="input"
                          id="dob"
                          name="dob"
                          label="Birth Date"
                          label="Birthday"
                          type="date"
                          // defaultValue="2017-05-24"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        /> */}

                        <FormikControl
                          control="checkbox"
                          id="isactive"
                          name="isactive"
                          label="Is Active"
                        />

                        <FormikControl
                          control="radio"
                          id="gender"
                          name="gender"
                          label="Gender"
                          formikobj={formik}
                        />

                        {/* <Autocomplete
                          // options={top100Films.map((option) => option.title)}
                          options={top100Films}
                          getOptionLabel={option => (option ? option.title : "")}
                          value={top100Films}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Autocomplete"
                              margin="normal"
                              variant="outlined"
                              fullWidth
                            />
                          )}
                          onChange={handleChangeAutocompleteList}
                        /> */}

                        {/* <FormikControl
                          control="autocompletelist"
                          id="listofstates"
                          name="listofstates"
                          label="List Of Movies"
                          formikobj={formik}
                        /> */}

                        {/* <FormikControl
                          control="auto"
                          id="listofstates"
                          name="listofstates"
                          label="List Of Movies"
                          formikobj={formik}
                          value={states}
                          // value={stateAutocompleteList}
                          // onChange={handleChangeAutocompleteList}
                        /> */}

                        {/* working */}
                        <Autocomplete
                          id="listofstates"
                          name="listofstates"
                          options={states}
                          value={stateAutocompleteList}
                          // value={states[0]}
                          // defaultValue={[states[13]]}
                          getOptionLabel={(option) =>
                            option ? option.name : ""
                          }
                          // getOptionSelected={(option, value) =>
                          //   option.name === value.name
                          // }
                          onChange={
                            // handleChangeAutocompleteList
                            (e, value) => {
                              console.log("Auto: ", value);
                              // setFieldValue(name, value);
                              setAutocompleteList(value);
                              // formik.setFieldTouched('listofstates',true)
                              try {
                                formik.setFieldValue("listofstates", [
                                  {
                                    name: `${value.name}`,
                                    abbr: `${value.abbr}`,
                                  },
                                ]);
                              } catch (err) {
                                formik.setFieldValue("listofstates", null);
                                // console.log("Autocomplete Error: ", err);
                              }
                            }
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="State"
                              // variant="outlined"
                            />
                          )}
                        />
                        {Object.keys(formik.errors).length > 0 && (
                          <div className="error">
                            {formik.errors.listofstates}
                          </div>
                        )}

                        {/* <FormikControl
                          control="autocompletelist"
                          id="listofstates"
                          name="listofstates"
                          label="States"
                          options={states}
                          formikobj={formik}
                        /> */}

                        {/* Working with disable on submit */}
                        {/* <Field
                          name="listofstates"
                          options={states}
                          getOptionLabel={(option) =>
                            option ? option.name : ""
                          }
                          component={AutocompleteList}
                          textFieldProps={{
                            label:"States",
                            // fullWidth: true,
                            margin: "normal",
                            // variant: "outlined",
                          }}
                          // multiple
                        /> */}

                        <FormikControl
                          control="selectlist"
                          id="age"
                          name="age"
                          yupname="listofage"
                          yupkey="age"
                          yupvalue="value"
                          formikobj={formik}
                        />

                        <FormikControl
                          control="switch"
                          id="active"
                          name="active"
                          label="Active"
                          formikobj={formik}
                        />

                        {/* <FormControl>
                          <InputLabel id="demo-simple-select-label">
                            Age
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            name="listofage"
                            value={age}
                            onBlur={() => {
                              console.log("Select Blur");
                              formik.setFieldTouched("listofage");
                            }}
                            onChange={
                              // handleChange;
                              (e, child) => {
                                console.log("List Of Age Change");
                                try {
                                  setAge(e.target.value);
                                  formik.setFieldValue("listofage", [
                                    {
                                      age: `${child.props.value}`,
                                      value: `${child.props.children}`,
                                    },
                                  ]);
                                  console.log("Select setFieldValue");
                                } catch (err) {
                                  setAge(null);
                                  formik.setFieldValue("listofage", null);
                                  console.log("Select setFieldValue ERROR");
                                }
                              }
                            }
                            autoWidth
                            // renderValue={(value) => `⚠️  - ${value}`}
                          >
                            <MenuItem value="">
                              <em>None</em>
                            </MenuItem>
                            <MenuItem value={10}>Ten</MenuItem>
                            <MenuItem value={20}>Twenty</MenuItem>
                            <MenuItem value={30}>Thirty</MenuItem>
                          </Select>
                          {Object.keys(formik.errors).length > 0 && (
                            <div className="error">
                              {formik.errors.listofage}
                            </div>
                          )}
                        </FormControl> */}

                        {/* <FormikControl
                          control="selectlist"
                          id="listofage1"
                          name="listofage1"
                          label="Age"
                          formikobj={formik}
                        /> */}

                        <FormikControl
                          control="grid"
                          id="employee"
                          name="employee"
                          // label="Active"
                          formikobj={formik}
                        />

                        <br />
                        <br />
                        {/* <button type="submit" disabled={!formik.isValid}>Submit</button> */}
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          disabled={!formik.isValid}
                        >
                          Submit
                        </Button>
                        <div ref={divdataRef}>Data</div>
                      </Form>
                    </div>
                    {/* /.card-body  */}
                    {/* </div> */}
                  </div>
                </div>
              </div>
            </section>
          </div>
        );
      }}
    </Formik>
  );
}

export default Employee;

// // Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
// const top100Films = [
//   { title: "The Shawshank Redemption", year: 1994 },
//   { title: "The Godfather", year: 1972 },
//   { title: "The Godfather: Part II", year: 1974 },
//   { title: "The Dark Knight", year: 2008 },
//   { title: "12 Angry Men", year: 1957 },
//   { title: "Schindler's List", year: 1993 },
//   { title: "Pulp Fiction", year: 1994 },
//   { title: "The Lord of the Rings: The Return of the King", year: 2003 },
//   { title: "The Good, the Bad and the Ugly", year: 1966 },
//   { title: "Fight Club", year: 1999 },
//   { title: "The Lord of the Rings: The Fellowship of the Ring", year: 2001 },
//   { title: "Star Wars: Episode V - The Empire Strikes Back", year: 1980 },
//   { title: "Forrest Gump", year: 1994 },
//   { title: "Inception", year: 2010 },
//   { title: "The Lord of the Rings: The Two Towers", year: 2002 },
//   { title: "One Flew Over the Cuckoo's Nest", year: 1975 },
//   { title: "Goodfellas", year: 1990 },
//   { title: "The Matrix", year: 1999 },
//   { title: "Seven Samurai", year: 1954 },
//   { title: "Star Wars: Episode IV - A New Hope", year: 1977 },
//   { title: "City of God", year: 2002 },
//   { title: "Se7en", year: 1995 },
//   { title: "The Silence of the Lambs", year: 1991 },
//   { title: "It's a Wonderful Life", year: 1946 },
//   { title: "Life Is Beautiful", year: 1997 },
//   { title: "The Usual Suspects", year: 1995 },
//   { title: "Léon: The Professional", year: 1994 },
//   { title: "Spirited Away", year: 2001 },
//   { title: "Saving Private Ryan", year: 1998 },
//   { title: "Once Upon a Time in the West", year: 1968 },
//   { title: "American History X", year: 1998 },
//   { title: "Interstellar", year: 2014 },
//   { title: "Casablanca", year: 1942 },
//   { title: "City Lights", year: 1931 },
//   { title: "Psycho", year: 1960 },
//   { title: "The Green Mile", year: 1999 },
//   { title: "The Intouchables", year: 2011 },
//   { title: "Modern Times", year: 1936 },
//   { title: "Raiders of the Lost Ark", year: 1981 },
//   { title: "Rear Window", year: 1954 },
//   { title: "The Pianist", year: 2002 },
//   { title: "The Departed", year: 2006 },
//   { title: "Terminator 2: Judgment Day", year: 1991 },
//   { title: "Back to the Future", year: 1985 },
//   { title: "Whiplash", year: 2014 },
//   { title: "Gladiator", year: 2000 },
//   { title: "Memento", year: 2000 },
//   { title: "The Prestige", year: 2006 },
//   { title: "The Lion King", year: 1994 },
//   { title: "Apocalypse Now", year: 1979 },
//   { title: "Alien", year: 1979 },
//   { title: "Sunset Boulevard", year: 1950 },
//   {
//     title:
//       "Dr. Strangelove or: How I Learned to Stop Worrying and Love the Bomb",
//     year: 1964,
//   },
//   { title: "The Great Dictator", year: 1940 },
//   { title: "Cinema Paradiso", year: 1988 },
//   { title: "The Lives of Others", year: 2006 },
//   { title: "Grave of the Fireflies", year: 1988 },
//   { title: "Paths of Glory", year: 1957 },
//   { title: "Django Unchained", year: 2012 },
//   { title: "The Shining", year: 1980 },
//   { title: "WALL·E", year: 2008 },
//   { title: "American Beauty", year: 1999 },
//   { title: "The Dark Knight Rises", year: 2012 },
//   { title: "Princess Mononoke", year: 1997 },
//   { title: "Aliens", year: 1986 },
//   { title: "Oldboy", year: 2003 },
//   { title: "Once Upon a Time in America", year: 1984 },
//   { title: "Witness for the Prosecution", year: 1957 },
//   { title: "Das Boot", year: 1981 },
//   { title: "Citizen Kane", year: 1941 },
//   { title: "North by Northwest", year: 1959 },
//   { title: "Vertigo", year: 1958 },
//   { title: "Star Wars: Episode VI - Return of the Jedi", year: 1983 },
//   { title: "Reservoir Dogs", year: 1992 },
//   { title: "Braveheart", year: 1995 },
//   { title: "M", year: 1931 },
//   { title: "Requiem for a Dream", year: 2000 },
//   { title: "Amélie", year: 2001 },
//   { title: "A Clockwork Orange", year: 1971 },
//   { title: "Like Stars on Earth", year: 2007 },
//   { title: "Taxi Driver", year: 1976 },
//   { title: "Lawrence of Arabia", year: 1962 },
//   { title: "Double Indemnity", year: 1944 },
//   { title: "Eternal Sunshine of the Spotless Mind", year: 2004 },
//   { title: "Amadeus", year: 1984 },
//   { title: "To Kill a Mockingbird", year: 1962 },
//   { title: "Toy Story 3", year: 2010 },
//   { title: "Logan", year: 2017 },
//   { title: "Full Metal Jacket", year: 1987 },
//   { title: "Dangal", year: 2016 },
//   { title: "The Sting", year: 1973 },
//   { title: "2001: A Space Odyssey", year: 1968 },
//   { title: "Singin' in the Rain", year: 1952 },
//   { title: "Toy Story", year: 1995 },
//   { title: "Bicycle Thieves", year: 1948 },
//   { title: "The Kid", year: 1921 },
//   { title: "Inglourious Basterds", year: 2009 },
//   { title: "Snatch", year: 2000 },
//   { title: "3 Idiots", year: 2009 },
//   { title: "Monty Python and the Holy Grail", year: 1975 },
// ];

const states = [
  {
    name: "Andaman and Nicobar Islands",
    abbr: "AN",
  },
  {
    name: "Andhra Pradesh",
    abbr: "AP",
  },
  {
    name: "Arunachal Pradesh",
    abbr: "AR",
  },
  {
    name: "Assam",
    abbr: "AS",
  },
  {
    name: "Bihar",
    abbr: "BR",
  },
  {
    name: "Chandigarh",
    abbr: "CG",
  },
  {
    name: "Chhattisgarh",
    abbr: "CH",
  },
  {
    name: "Dadra and Nagar Haveli",
    abbr: "DN",
  },
  {
    name: "Daman and Diu",
    abbr: "DD",
  },
  {
    name: "Delhi",
    abbr: "DL",
  },
  {
    name: "GOA",
    abbr: "GA",
  },
  {
    name: "Gujarat",
    abbr: "GJ",
  },
  {
    name: "Haryana",
    abbr: "HR",
  },
  {
    name: "Himachal Pradesh",
    abbr: "HP",
  },
  {
    name: "Jammu and Kashmir",
    abbr: "JK",
  },
  {
    name: "Jharkhand",
    abbr: "JH",
  },
  {
    name: "Karnataka",
    abbr: "KA",
  },
  {
    name: "Kerala",
    abbr: "KL",
  },
  {
    name: "Ladakh",
    abbr: "LA",
  },
  {
    name: "Lakshadweep",
    abbr: "LD",
  },
  {
    name: "Madhya Pradesh",
    abbr: "MP",
  },
  {
    name: "Maharashtra",
    abbr: "MH",
  },
  {
    name: "Manipur",
    abbr: "MN",
  },

  {
    name: "Meghalaya",
    abbr: "ML",
  },
  {
    name: "Mizoram",
    abbr: "MZ",
  },
  {
    name: "Nagaland",
    abbr: "NL",
  },
  {
    name: "Odisha",
    abbr: "OR",
  },
  {
    name: "Puducherry",
    abbr: "PY",
  },
  {
    name: "Punjab",
    abbr: "PB",
  },
  {
    name: "Rajasthan",
    abbr: "RJ",
  },
  {
    name: "Sikkim",
    abbr: "SK",
  },
  {
    name: "Tamil Nadu",
    abbr: "TN",
  },
  {
    name: "Telangana",
    abbr: "TS",
  },
  {
    name: "Tripura",
    abbr: "TR",
  },
  {
    name: "Uttar Pradesh",
    abbr: "UP",
  },
  {
    name: "Uttarakhand",
    abbr: "UK",
  },
  {
    name: "West Bengal",
    abbr: "WB",
  },
];
